import { render, staticRenderFns } from "./ClassroomCard.vue?vue&type=template&id=2b99528e&scoped=true"
import script from "./ClassroomCard.vue?vue&type=script&lang=js"
export * from "./ClassroomCard.vue?vue&type=script&lang=js"
import style0 from "./ClassroomCard.vue?vue&type=style&index=0&id=2b99528e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99528e",
  null
  
)

export default component.exports